import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore, sel } from '../../store/useAppStore.js';

/**
 * Blocks host-only screens for guest participants (users who joined a
 * session they don't host). Guests are redirected to /session when
 * a session is active, otherwise to /join.
 */
export const GuestGuard = ({ children }) => {
  const navigate = useNavigate();
  const isGuest  = useAppStore(sel.isGuest);
  const session  = useAppStore(sel.session);

  useEffect(() => {
    if (!isGuest) return;
    navigate(session ? '/session' : '/join', { replace: true });
  }, [isGuest, session, navigate]);

  if (isGuest) {
    return (
      <div className="min-h-dvh bg-surface flex items-center justify-center">
        <div className="text-4xl animate-bounce-soft">⚡</div>
      </div>
    );
  }
  return children;
};